import { Injectable } from '@angular/core';
import { FetchHelper } from '../../../../core/helpers/fetch-helper';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  async getLinhVuc() {
    return await FetchHelper.get('/system/SysCategories/GetAllByCategoryTypeId', { id: 243 });
  }

  async getCategoryCounts() {
    return await FetchHelper.get('/system/Kehoach/CountByLinhVuc');
  }
}
